import { CalendricalType } from '~/client/graph'

import { enumToList } from './converters'

export const calendricalTypes = enumToList(CalendricalType)
export const recurringTypes = calendricalTypes.filter(
  t => t !== CalendricalType.Month,
)
